import {
    AbstractPmsApiService
} from "./abstract.service";
import {
    ReservationAccommodation
} from "../models";
import { handlePriceBelowMinimumError } from "../../helpers";


export class ReservationAccommodationPmsApiService extends AbstractPmsApiService {

    get urlPattern() {

        return '/reservation/:reservationId/accommodation(/:id)';
    }

    newModel(attributes, ...params) {

        return new ReservationAccommodation(attributes);
    }

    /**
     * Shows the price-below-minimum warning when applicable, then re-rejects so
     * the existing caller error handling keeps working. Used on the methods that
     * intentionally bypass `getErrorHandler`.
     *
     * @returns {function(error: Object): Promise.<Object>}
     * @protected
     */
    priceLimitRejector() {

        return (error) => {

            handlePriceBelowMinimumError(error, {
                $uibModal: this.$injector.get('$uibModal'),
                $translate: this.$injector.get('$translate')
            });

            return Promise.reject(error);
        };
    }

    get(reservation, params = {}) {

        const url = this.url({
            reservationId: reservation.id
        });

        return this.http
            .get(url, {
                headers: this.authHeaders
            })
            .then(this.getMassModeler())
            .catch(this.getErrorHandler());
    }

    save(accommodations, reservation, toDelete) {

        const url = this.url({
            reservationId: reservation.id,
        });

        return this.http
            .post(url, {
                accommodations: accommodations,
                to_delete: toDelete,
            }, {
                headers: this.authHeaders
            })
            .then(this.getDataExtractor())
            .catch(this.priceLimitRejector());
    }

    update(accommodation, reservation, checkout_date = null, lang = "en") {

        const url = this.url({
            reservationId: reservation.id,
            id: accommodation.id,
        });
        const data = Object.assign({}, accommodation.attributes || accommodation, {
            checkout_date: checkout_date,
            lang: lang
        });


        return this.http
            .put(url, data, {
                headers: this.authHeaders
            })
            .catch(this.priceLimitRejector());
    }

    updateFromCalendar(accommodations, reservation, toDelete) {

        const url = this.url({
            reservationId: reservation.id,
        }) + '/update-from-calendar';

        return this.http.post(url, {
            accommodations: accommodations,
            to_delete: toDelete,
        }, {
            headers: this.authHeaders
        });
    }

    delete(accommodation, roomID = null) {

        let url = this.url({
            reservationId: accommodation.reservation.id,
            id: accommodation.id
        });

        roomID = (Array.isArray(roomID))? roomID[0]: null; 

        if(roomID !== null) url += '/room/' + roomID;

        return this.http.delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    loadTypeFreeRooms(type, params) {

        const url = this.url({}, `/accommodation-type/${type.id}/load-occupied-rooms`);

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params
            })
            .catch(this.getErrorHandler());
    }

    loadFreeRooms(type, params) {

        const url = this.url({}, `/accommodation-type/${type.id}/load-free-rooms`);

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }

    validateRoom(type,room, params) {

        const url = this.url({}, `/accommodation-type/${type.id}/validate-room/${room.id}`);

        return this.http
            .post(url, params,{
                headers: this.authHeaders,            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }

    deleteAddon(accommodation, addon){

        const url = this.url({}, `/accommodation/${accommodation.id}/unlink-addon/${addon.addon_id}`);

        return this.http.post(url, {}, {
            headers: this.authHeaders
        }).catch(this.getErrorHandler());
    }

    bulkUpdate(accommodations, property) {

        const url = this.url({}, `/property/${property.id}/accommodations-bulk-update`);

        return this.http.post(url, {'accommodations': accommodations}, {
            headers: this.authHeaders
        }).catch(this.getErrorHandler());
    }

    loadGuestAvailableRooms(guest, reservation) {

        const url = this.url({}, `/reservation/${reservation.id}/load-guest-available-rooms/${guest.id || 0}/child/${guest.is_child || 0}`);

        return this.http.get(url, {
            headers: this.authHeaders
        })
        .then(this.getMassModeler())
        .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/reservation-accommodation.service.js